module.exports = __webpack_public_path__ + "img/admin-avatar.c1e0a126.svg";